import { CookieService } from './Services/CookieService';
import constants from './constants';

export class CookieSettingsModule {
    
    constructor() {
        this.settingsCookie = new CookieService(constants.COOKIES.SETTINGS_COOKIE);
        this.hasTakenCookieActionCookie = new CookieService(constants.COOKIES.ACTION_COOKIE);

        this.cookieBanner = document.getElementById('cookie-disclaimer');
        this.cookieBannerButton = document.querySelector('[data-cookie-accept-all-btn]');

        this.form = document.getElementById('cookie-settings-form');

        this.successElement = document.getElementById('updated-cookie-settings');

        this.selectors = {
            checkboxes: "input[name='cookie-setting-level']",
            checkedBoxes: "input[name='cookie-setting-level']:checked",
            cookieLevelAllCheckedBox: "input[value='cookie-level-all']:checked",
        };

        this.addListeners();
    }

    addListeners() {
        // click directly from cookiebanner
        if (this.cookieBannerButton) {
            this.cookieBannerButton.addEventListener('click', (e) => this.acceptAllCookies());
        }

        if (this.form) {
            this.form.addEventListener('submit', (e) => { this.saveCookieSettings(e); });
            this.form.addEventListener('change', (e) => { this.handleFormChanges(e); });
        }
    }

    saveCookieSettings(e) {
        e.preventDefault();

        const checkedBoxes = document.querySelectorAll(this.selectors.checkedBoxes);
        let values = [];

        for (let i = 0; i < checkedBoxes.length; i++) {
            values.push(checkedBoxes[i].value);
        }

        if (values.length) {
            this.storeCookieLevelCookie(values);
          } else {
            this.settingsCookie.deleteCookie();
            this.storeActionCookie();
        }

        this.renderSuccessElement();
        this.removeCookieBanner();
    }

    renderSuccessElement() {
        this.successElement.classList.add('active');

        setTimeout(() => {
            this.successElement.classList.remove('active');
        }, 2500); 
    }

    handleFormChanges() {
        if (this.hasCheckedAllCookiesCheckbox()) {
            this.clearCheckboxesExceptAll();
            this.disableCheckboxesExceptAll();
        } else {
            this.enableCheckboxes();
        }
    }

    hasCheckedAllCookiesCheckbox() {
        const allCheckbox = document.querySelector(this.selectors.cookieLevelAllCheckedBox);
        return (allCheckbox) ? true : false;
    }

    clearCheckboxesExceptAll() {
        const checkedBoxes = document.querySelectorAll(this.selectors.checkedBoxes);

        for (let i = 0; i < checkedBoxes.length; i++) {
            if (checkedBoxes[i].value !== 'cookie-level-all') {
                checkedBoxes[i].checked = false;
            }
        }
    }

    disableCheckboxesExceptAll() {
        const checkBoxes = document.querySelectorAll(this.selectors.checkboxes);

        for (let i = 0; i < checkBoxes.length; i++) {
            if (checkBoxes[i].value !== 'cookie-level-all') {
                checkBoxes[i].disabled = true;
            }
        }
    }

    enableCheckboxes() {
        const checkBoxes = document.querySelectorAll(this.selectors.checkboxes);

        for (let i = 0; i < checkBoxes.length; i++) {
            checkBoxes[i].disabled = false;
        }
    }

    removeCookieBanner() {
        if (!this.cookieBanner || !this.cookieBanner.parentNode) {
            return;
        }

        if (this.hasTakenCookieActionCookie.getCookieValue()) {
            this.cookieBanner.parentNode.removeChild(this.cookieBanner);
        }
    }

    acceptAllCookies() {
        let value = ['cookie-level-all'];
        this.storeCookieLevelCookie(value);
        this.storeActionCookie();
        this.dispatchEvent();
        this.removeCookieBanner();
    }

    dispatchEvent() {
        const event = new CustomEvent(constants.EVENTS.GTM_DISPATCH);
        document.querySelector('body').dispatchEvent(event);
    }

    storeCookieLevelCookie(cookieValues) {
        let value = cookieValues.join('|');
        this.settingsCookie.deleteCookie();
        this.settingsCookie.setCookie(null, value);
        this.storeActionCookie();
    }

    storeActionCookie() {
        let expires = this.hasGivenAnyConsent() ? null : 60 * 60 * 24; /* store 1 day if not given consent to any cookies. Otherwise 1 year */
        this.hasTakenCookieActionCookie.deleteCookie();
        this.hasTakenCookieActionCookie.setCookie(expires, true);
    }

    hasGivenAnyConsent() {
        let value = this.settingsCookie.getCookieValue();

        if (!value) {
            return false;
        }

        let cookieLevels = value.split('|');
        return cookieLevels.length ? true : false;
    }
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/lynx-hedge/assets/scripts/src/App/CookieSettingsModule.js